export const LABS_BASE_API_URL = '/labs/';
export const labBaseApiUrl = labId => {
  return `${LABS_BASE_API_URL}${labId}/`;
};
export const labTasksApiUrl = labId => {
  return `${labBaseApiUrl(labId)}tasks/`;
};
export const labInstanceBaseApiUrl = labId => {
  return `${labBaseApiUrl(labId)}instance/`;
};
export const labInstanceApiUrl = (labId, labInstanceId) => {
  return `${labInstanceBaseApiUrl(labId)}${labInstanceId}/`;
};
export const stopLabInstanceApiUrl = (labId, labInstanceId) => {
  return `${labInstanceApiUrl(labId, labInstanceId)}stop/`;
};
export const terminateLabInstanceApiUrl = (labId, labInstanceId) => {
  return `${labInstanceApiUrl(labId, labInstanceId)}terminate/`;
};
export const LAB_REFRESH_AND_RETRIEVE_LABS_URL = `${LABS_BASE_API_URL}retrieve-running-labs/`;
//# sourceMappingURL=apis.js.map